export const AGENDA_FEATURE_FLAGS = {
  weatherRow: true,
  rainAlerts: true,
  bulkWhatsAppRainAlert: false,
  postVisitPanelActions: true,
  bulkBlockAction: true,
} as const;
